var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.75V6.75C12.5 7.08152 12.6317 7.39946 12.8661 7.63388C13.1005 7.8683 13.4185 8 13.75 8H18.75M12.5 1.75H3.75C3.08696 1.75 2.45107 2.01339 1.98223 2.48223C1.51339 2.95107 1.25 3.58696 1.25 4.25V21.75C1.25 22.413 1.51339 23.0489 1.98223 23.5178C2.45107 23.9866 3.08696 24.25 3.75 24.25H16.25C16.913 24.25 17.5489 23.9866 18.0178 23.5178C18.4866 23.0489 18.75 22.413 18.75 21.75V8M12.5 1.75L18.75 8M7.5 20.5L13.75 14.25C14.0815 13.9185 14.2678 13.4688 14.2678 13C14.2678 12.5312 14.0815 12.0815 13.75 11.75C13.4185 11.4185 12.9688 11.2322 12.5 11.2322C12.0312 11.2322 11.5815 11.4185 11.25 11.75L5 18V20.5H7.5Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.998ec0301e5de0efb8355ba2115817e9.svg";
export { ForwardRef as ReactComponent };